import { render, staticRenderFns } from "./PlusConfigure.vue?vue&type=template&id=53d45d3a&scoped=true"
import script from "./PlusConfigure.vue?vue&type=script&lang=js"
export * from "./PlusConfigure.vue?vue&type=script&lang=js"
import style0 from "./PlusConfigure.vue?vue&type=style&index=0&id=53d45d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d45d3a",
  null
  
)

export default component.exports